<template>
<!-- 企业名称 企业住所 企业法人 统一社会信用代码  成立日期  -->
    <div class="box">
        <div class="contaner-title"><span>个人中心</span> <span>/ 供应商认证</span></div>
        <div class="hr"></div>
        <div class="contaner">
           <div><img src="../../assets/user_icon.png" alt=""> <span>供应商认证</span></div>
           <p class="tipComment" :class="{'tipsActive':Status==3}" v-if="(Status==1||Status==3)&&Info.AuditTime">{{Info.AuditTime}} 
               <span v-if="Status==1&&Info.AuditComment">审核退回 ： {{Info.AuditComment}}</span>
               <span v-if="Status==3">审核通过</span>
               </p>
			<Button v-if="Status == 3" type="success" class="supplierinfo" @click="handlemodifyInfo">修改供应商信息</Button >
             <div v-if="Status==1 || Status == 4">
                 <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="200">
                      <FormItem label="供应商类型" prop="type">
                            <RadioGroup v-model="formValidate.type">
                               <Radio :label="1"><span>个人</span></Radio>
                               <Radio :label="2"><span>工作室 / 公司</span></Radio>
                             </RadioGroup>
                      </FormItem>
                    <FormItem label="规模"  prop="Scale"  v-if="formValidate.type==2">
                        <Select style="width:120px;" v-model="formValidate.Scale" placeholder="">
                            <Option value="10-50">10-50人</Option>
                            <Option value="51-200">51-200人</Option>
                            <Option value="201-300">201-300人</Option>
                        </Select>
                    </FormItem>
                    <FormItem label="有效证件" prop="ValidCertificate" >
                        <div style="display:flex;" class="uploadImg">
                            <div v-if="formValidate.ValidCertificate.length>0" v-for="(item,index) in formValidate.ValidCertificate" >
                                    <img  style="width:154px;height:94px;margin-right:10px;" :src="imgUrl+item" alt="">
                                    <Icon type="md-close" @click="deleValid(index)" />
                            </div>
                             <Upload accept=".jpg,.png,.jpeg,.gif,.bmp,.svg"  :show-upload-list="false":action="uploadUrl" :on-success="successValid" >
                              <Button type="primary" >点击上传</Button>
                             </Upload>
                            <span>（个人,工作室用户请上传身份证正反面，公司用户请上传企业营业执照）</span>
                        </div>
                    </FormItem>
                     <FormItem v-if="formValidate.type==2" label="企业名称" prop="CompanyName" >
                        <Input style="width:474px;"  v-model="formValidate.CompanyName"  placeholder="请输入企业名称"></Input>
                    </FormItem>
                     <FormItem v-if="formValidate.type==2" label="企业住所" prop="CompanyAddress" >
                        <Input style="width:474px;" v-model="formValidate.CompanyAddress"  placeholder="请输入企业住所"></Input>
                    </FormItem>
                        <FormItem v-if="formValidate.type==2" label="企业法人" prop="CompanyLeader" >
                        <Input style="width:474px;"  v-model="formValidate.CompanyLeader"  placeholder="请输入企业法人"></Input>
                    </FormItem>
                       <FormItem v-if="formValidate.type==2" label="社会统一信用代码" prop="CompanyCode" >
                        <Input style="width:474px;" v-model="formValidate.CompanyCode"  placeholder="请输入社会统一信用代码"></Input>
                    </FormItem>
                       <FormItem v-if="formValidate.type==2" label="企业成立日期" prop="CompanyDate" >
                       <DatePicker format="yyyy-MM-dd" type="date" @on-change="getDate" v-model="CompanyDate" placeholder="请选择企业成立日期" style="width: 200px"></DatePicker>
                    </FormItem>
                    <FormItem label="项目制作经历" prop="content" >
                        <Input style="width:474px;" :rows="8" type="textarea"  v-model="formValidate.content" placeholder=""></Input>
                    </FormItem>
                     <FormItem label="通讯地址" prop="TelAddress" >
                       <area-select v-if="showArea" v-model="formValidate.TelAddress" :data="$pcaa" :level="2"></area-select>  
                    </FormItem>
                      <FormItem label="" prop="DetailedAddress" >
                        <Input style="width:474px;"  v-model="formValidate.DetailedAddress" placeholder="请输入详细地址"></Input>
                    </FormItem>
                     <FormItem label="联系人" prop="ContactName" >
                        <Input style="width:474px;"  v-model="formValidate.ContactName" placeholder="请输入联系人"></Input>
                    </FormItem>
                     <FormItem label="联系方式" prop="ContactWay" >
                        <Input style="width:474px;"  v-model="formValidate.ContactWay" placeholder="请输入联系方式"></Input>
                    </FormItem>
                    <FormItem label="作品展示"   prop="Exhibition">
                             <OssUplad ref="ossChild" @func="getMsgFormSon"></OssUplad>
                             <ul class="file-list">
                                 <li v-for="(item,index) in formValidate.Exhibition"><span @click="downLoad(item)">{{item}}</span><Icon @click="deleFile(item,index)" type="md-close" /></li>
                             </ul>
                    </FormItem>
                    <div class="btn-sub">
                        <Button v-if="Status==1" type="success" size="large" @click="handleSubmit('formValidate')">
                            <span v-show="Status == 1">提交认证</span>
                        </Button>
						<Button v-if="Status==4" type="success" size="large" @click="handleSubmitModify('formValidate')">
                            <span>确认修改信息</span>
                        </Button>
                    </div>
    </Form>
  </div>
   <div class="tips" v-if="Status==2">
        <Icon size="46" style="color:#2EB135;" type="md-checkmark-circle" />
        <span v-if="Number($getLS('showMOdifyTips')) === 1">更新供应商信息已提交。</span>
        <span v-if="Number($getLS('showMOdifyTips')) === 0 || !Number($getLS('showMOdifyTips'))">供应商认证已提交，请耐心等待工作人员审核</span>
    </div>
      <div class="tips"  v-if="Status==0">
        <Icon size="46" style="color:#FF2626;" type="md-close-circle" /><span >请先<span class="improveinfo" @click="handleImproveInfo"> 完善用户 </span>资料，再重新提交认证！</span>
    </div>
 </div>
    </div>
</template>
<script>
import OssUplad from "../../components/OssUpload";
export default {
       components: {
         OssUplad
        },
    data(){
        return{
            CompanyDate:'',
            showArea:false,
            uploadUrl:this.$base,
            modal:true,
            formValidate: {
                    type:1,//类型
                    Scale:'',//规模
                    ValidCertificate:[],//有效证件
                    content:'',//内容
                    Exhibition:[],//作品展示
                    TelAddress:[],
                    DetailedAddress:'',
                    CompanyName:'',
                    CompanyAddress:'',
                    CompanyLeader:'',
                    CompanyCode:'',
                    CompanyDate:'',
                    ContactWay:'',
                    ContactName:''
                },
                ruleValidate: {
                    type: [{ required: true,type: 'number', message: '供应商类型不能为空', trigger: 'change' }],
                    ValidCertificate: [{ required: true, type: 'array',message: '有效证件不能为空', trigger: 'change' }],
                    content:[ { required: true,type: 'string', message: '项目制作经历不能为空', trigger: 'blur' }],
                    DetailedAddress:[ { required: true,type: 'string', message: '详细地址不能为空', trigger: 'blur' }],
                    ContactName:[ { required: true,type: 'string', message: '联系人不能为空', trigger: 'blur' }],
                    ContactWay:[ { required: true,type: 'string', message: '联系方式不能为空', trigger: 'blur' }],
                    TelAddress:[ { required: true,type: 'array', message: '通讯地址不能为空', trigger: 'change' }],
                    Exhibition:[ { required: true,type: 'array', message: '作品展示不能为空' , trigger: 'change' }],
                    CompanyName:[ { required:true,type: 'string', message: '企业名称不能为空', trigger: 'blur' }],
                    CompanyAddress:[ { required:true,type: 'string', message: '企业住所不能为空', trigger: 'blur' }],
                    CompanyLeader:[ { required:true,type: 'string', message: '企业法人不能为空', trigger: 'blur' }],
                    Scale:[ { required:true,type: 'string', message: '规模不能为空', trigger: 'change' }]
                },
                Status:0,//（0：资料未完善；1：未认证；2：待审核；3：审核通过）
                imgUrl:this.$baseImg,
                UserID:0,
                Info:{}
        }
    },
    mounted(){
        this.getInfo().then(res=>{
            if(res){
                
        // if(this.$getLS('AdminInfo')){
                this.Status=res.Status;
                this.UserID=res.ID;
                this.Info=res;
                this.formValidate.type=this.Info.VerifyType;
                this.formValidate.Scale=this.Info.Scale;
                this.formValidate.content=this.Info.ItemProcess;
                this.formValidate.DetailedAddress=this.Info.DetailedAddress;
                this.formValidate.TelAddress=this.Info.TelAddress;
                this.formValidate.CompanyName=this.Info.CompanyName;
                this.formValidate.CompanyAddress=this.Info.CompanyAddress;
                this.formValidate.CompanyLeader=this.Info.CompanyLeader;
                this.formValidate.CompanyCode=this.Info.CompanyCode;
                this.formValidate.CompanyDate=this.Info.CompanyDate;
                this.formValidate.ContactName=this.Info.ContactName;
                this.formValidate.ContactWay=this.Info.ContactWay;
                this.CompanyDate=this.Info.CompanyDate;
                if(this.Info.Certificate){
                    this.formValidate.ValidCertificate=this.Info.Certificate;
                }
                if(this.Info.FilePath){
                    this.formValidate.Exhibition=this.Info.FilePath;
                }
                if(!this.formValidate.TelAddress){
                    this.showArea = false;
                    this.formValidate.TelAddress=[];
                    this.$nextTick(() => {
                        this.showArea = true;
                    })
                }else{
                    this.formValidate.TelAddress=[this.formValidate.TelAddress.Province,this.formValidate.TelAddress.City,this.formValidate.TelAddress.Area]
                    this.$nextTick(() => {
                        this.showArea = true;
                    })
                }
        // }
            }
        })
        // 18969025950
    },
    methods:{
        // 获取用户信息
        getInfo(){
            const that = this
            return new Promise((resolve=>{
                that.$post('api/manage.PersonCenter/getMemberInfo').then(res=>{
                    if(res.code==1){
                        resolve(res.data)
                    }
                })

            }))
        },
        getDate(val){
            this.formValidate.CompanyDate=val;
        },
        deleValid(index){
            this.formValidate.ValidCertificate.splice(index,1);
        },
        successValid(res){//有效证件上传成功
            if(res.code==1){
                this.formValidate.ValidCertificate.push(res.Path);
            }
        },
        getMsgFormSon(res){
             this.formValidate.Exhibition.push(res.Url);
        },
        downLoad(item){//下载文件
                const link = document.createElement('a')
                link.download = item;
                link.href = this.imgUrl+item;
                link.target = '_blank';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
        },
        deleFile(item,index){
            this.formValidate.Exhibition.splice(index,1)
        },
		handleSubmit(name) {
            this.$setLS('showMOdifyTips', 0)
            this.funcjudge(name)
        },
        handleSubmitModify(name){
            this.$setLS('showMOdifyTips', 1)
            this.funcjudge(name)
        },
        funcjudge(name){
			this.$refs[name].validate((valid) => {
				if (valid) {
					this.submit();
				} else {
					this.$Message.error('请将必填内容填写完整!');
				}
			})
        },
        submit(){//提交认证
            if(this.formValidate.type==1){
                this.formValidate.Scale='';
            }
            var TelAddress = {Province:'',City:'',Area:''}
        if(this.formValidate.TelAddress.length==3){
                TelAddress.Province=this.formValidate.TelAddress[0];
                TelAddress.City=this.formValidate.TelAddress[1];
                TelAddress.Area=this.formValidate.TelAddress[2];
            }
            var param={
                ID:this.UserID,
                VerifyType:this.formValidate.type,
                Scale:this.formValidate.Scale,
                Certificate:this.formValidate.ValidCertificate,
                ItemProcess:this.formValidate.content,
                FilePath:this.formValidate.Exhibition,
                DetailedAddress:this.formValidate.DetailedAddress,
                TelAddress:TelAddress,
                CompanyName:this.formValidate.CompanyName,
                CompanyAddress:this.formValidate.CompanyAddress,
                CompanyLeader:this.formValidate.CompanyLeader,
                CompanyCode:this.formValidate.CompanyCode,
                CompanyDate:this.formValidate.CompanyDate,
                ContactName:this.formValidate.ContactName,
                ContactWay:this.formValidate.ContactWay
            }
            this.$post('api/manage.PersonCenter/addMemberVerify',param).then(res=>{
                if(res.code==1){
                    this.Status=2;
                    this.Info.Status=2;
                    this.$setLS('AdminInfo',JSON.stringify(this.Info));
                    this.$Message.success(res.msg)
                }else{
                    this.$Message.error(res.msg)
                }
            })
        },
        handleImproveInfo(){
            this.$router.push({
                name: 'UserInfo',
                params: {
                    text: '完善用户资料'
                }
            })
        },
        // 修改供应商信息
        handlemodifyInfo(){
            this.showMOdifyTips = true
            this.Status = 4
        }
    }
}
</script>
<style lang="less" scoped>
.box{
    padding:30px;
    box-sizing: border-box;
    // height : 100%;
    .contaner{
        background-color: #fff;
        margin-top: 30px;
        box-shadow: 0px 3px 5px rgb(200, 204, 209);
        height : 100%;
        overflow: hidden;
        >div:nth-of-type(1){
            overflow: hidden;
            padding:25px;
            border-bottom: 1px solid #E6E9EB;
            img{
                float: left;
            }
            span{
                float: left;
                font-size: 22px;
                color:#334659;
                margin-left: 10px;
            }
        }
        >div:nth-of-type(2){
            padding:30px 0px;
            box-sizing: border-box;
            .btn-sub{
             border-top: 1px solid #eee;
            padding-top: 20px; 
            text-align: center;
            }
            
        }
        .uploadImg{
            >div{
                position: relative;
                padding-right:10px;
                img{
                    width: 154px;
                    height: 94px;
                    margin-right: 10px;
                }
                i{
                    position: absolute;
                    right:0px;
                    top:-10px;
                    font-size: 20px;
                    cursor: pointer;
                }

            }
        }
        .file-list{
         
            width: 500px;
            li{
                   overflow: hidden;
                   cursor: pointer;
            span{
                float: left;
            }
            i{
                float: right;
                cursor: pointer;
            }
            }
           
        }
    }
}
.tips{
               width:400px; margin:100px auto;display:flex;font-weight:bold;
                   span{
                      margin-top:12px;
                      >a{
                         color:#0098CC;
                         text-decoration: underline;
                      }
                   }
            }
            .tipComment{
                color: #B45C5A;
                padding:10px;
                border-radius: 5px;
                border:1px solid #EBCCD1;
                margin:20px;
                background-color:#F2DEDE;
            }
            .tipsActive{
                  color: #3B763D;
                border:1px solid #D6E9C6;
                background-color:#DFF0D8;
            }
            .improveinfo{
                cursor: pointer;
                color: #0198CD;
            }
        .supplierinfo {
            color: #fff;
            margin: 0 20px 20px 20px;
        }
        .ivu-btn-success {
            border: #0198cd;
            background: #0198cd;
        }
</style>






// WEBPACK FOOTER //
// src/view/HomePage/SupplierCert.vue